import { toValue } from 'vue'
import { storeToRefs } from 'pinia'
import { useCurrencyStore } from '@/stores/CurrencyStore'
import MultiCurrency from '@/classes/currencies/MultiCurrency'

export function useMoney () {
  const { getFormatedNumber } = useCurrencyStore()
  const { currency: selectedCurrency } = storeToRefs(useCurrencyStore())

  const getAmount = ({ amount, currency }) => amount && typeof toValue(amount) === 'object' ? toValue(amount)[toValue(currency) || selectedCurrency.value] || 0 : toValue(amount) || 0

  const isConvertedAmount = ({ amount, currency }) => toValue(amount) instanceof MultiCurrency && toValue(amount).isConverted(toValue(currency) || selectedCurrency.value)

  const getFormatedAmount = ({ amount, currency, showCurrency = true }) => {
    const curr = toValue(currency) || selectedCurrency.value
    const number = parseFloat(getAmount({ amount, currency: curr }))

    return getFormatedNumber(number / 100, { currency: curr, style: toValue(showCurrency) ? 'currency' : 'decimal' })
  }

  return {
    getAmount,
    getFormatedAmount,
    isConvertedAmount
  }
}